export default __webpack_public_path__ + "static/media/thought.7f90ff6c.svg";